// extracted by mini-css-extract-plugin
export var aircallIframe = "_gg-3";
export var fabContainer = "_gg-5";
export var fabRinging = "_gg-6";
export var loadingOverlay = "_gg-4";
export var pulse = "_gg-7";
export var widgetContent = "_gg-2";
export var widgetPanel = "_gg-0";
export var widgetPanelExpanded = "_gg-1";